var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReports(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 17.8889C11.862 17.8889 12.1657 17.7662 12.4111 17.5209C12.6564 17.2756 12.7786 16.9723 12.7778 16.6111C12.7778 16.2491 12.6551 15.9458 12.4098 15.7013C12.1644 15.4569 11.8612 15.3342 11.5 15.3333C11.138 15.3333 10.8347 15.456 10.5902 15.7013C10.3457 15.9467 10.2231 16.2499 10.2222 16.6111C10.2222 16.9731 10.3449 17.2768 10.5902 17.5222C10.8356 17.7675 11.1388 17.8897 11.5 17.8889ZM10.2222 12.7778H12.7778V5.11111H10.2222V12.7778ZM6.70833 23L0 16.2917V6.70833L6.70833 0H16.2917L23 6.70833V16.2917L16.2917 23H6.70833Z",
    fill: "#626262"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReports);
export default __webpack_public_path__ + "static/media/reports.0dbacaee3c2862607d08bb6e8d1249f6.svg";
export { ForwardRef as ReactComponent };